/**
 * Owner: Masa Bayu
 * File: selection-manager.ts
 * Date:Time: 2026-10-05 15:27
 * Description: Fasa 25 GREEN · selection normalize · optional document atomOrder.
 */
/**
 * Document order · prefer atomOrder index (production) · else atomId string (TDD).
 */
function comparePoints(a, b, atomOrder) {
    if (a.atomId !== b.atomId) {
        if (atomOrder && atomOrder.length > 0) {
            const ai = atomOrder.indexOf(a.atomId);
            const bi = atomOrder.indexOf(b.atomId);
            if (ai !== -1 && bi !== -1)
                return ai - bi;
        }
        return a.atomId < b.atomId ? -1 : 1;
    }
    return a.wordIndex - b.wordIndex;
}
/**
 * Update selection from an active drag point.
 * Stores absolute boundaries only · start = min · end = max.
 * atomOrder = document-linear ids when string id order ≠ reading order.
 */
export function updateSelection(currentRange, newPoint, atomOrder) {
    if (!currentRange) {
        return { start: newPoint, end: newPoint };
    }
    const isBeforeStart = comparePoints(newPoint, currentRange.start, atomOrder) < 0;
    const isAfterEnd = comparePoints(newPoint, currentRange.end, atomOrder) > 0;
    const newStart = isBeforeStart ? newPoint : currentRange.start;
    const newEnd = isAfterEnd ? newPoint : currentRange.end;
    return {
        start: newStart,
        end: newEnd,
    };
}
//# sourceMappingURL=selection-manager.js.map